import { TwoFactorAuthenticationFormFieldValues } from "./types"
import { useLoginFetcher, useLoginService } from "../../providers/LoginService"
import { useNavigationService } from "../../providers/NavigationService"

export const use2fa = () => {
  const { navigate, redirectToApp, search } = useNavigationService()
  const { getStoredCredentials, removeStoredCredentials, persistBrowserToken } = useLoginService()
  const { login, ...fetcher } = useLoginFetcher()

  const handleLogin = async ({ two_fa_code, trust_browser }: TwoFactorAuthenticationFormFieldValues) => {
    const storedCredentials = getStoredCredentials()
    if (!storedCredentials) return navigate("/")

    try {
      const { data } = await login({
        ...storedCredentials, two_fa_code
      }, {
        trust_browser, token: search.token
      })

      !!data?.browser_token && persistBrowserToken(data.browser_token)
      removeStoredCredentials()
      redirectToApp(data)
    } catch (error) {
      console.error(error)
    }
  }

  return { handleLogin, ...fetcher }
}
